export function validateDeliverableEmail(email: string): string | null {
  const trimmedEmail = email.trim().toLowerCase();
  const parts = trimmedEmail.split('@');

  if (parts.length !== 2) {
    return 'Please enter a valid email address';
  }

  const [localPart, domain] = parts;
  if (!localPart || !domain) {
    return 'Please enter a valid email address';
  }

  if (localPart.length > 64 || domain.length > 253) {
    return 'Please enter a valid email address';
  }

  if (!/^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+$/i.test(localPart)) {
    return 'Please enter a valid email address';
  }

  if (!domain.includes('.')) {
    return 'Enter an email with a valid domain after @';
  }

  const labels = domain.split('.');
  const domainIsValid = labels.every((label) => {
    return (
      label.length > 0 &&
      label.length <= 63 &&
      !label.startsWith('-') &&
      !label.endsWith('-') &&
      /^[a-z0-9-]+$/i.test(label)
    );
  });

  if (!domainIsValid) {
    return 'Enter an email with a valid domain after @';
  }

  const topLevelDomain = labels[labels.length - 1];
  if (!/^[a-z]{2,}$/i.test(topLevelDomain)) {
    return 'Enter an email with a valid domain after @';
  }

  return null;
}
